import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { LoginService } from '../../Services/login.service';
import { ActivatedRoute } from '@angular/router';
import * as moment from 'moment';
import { invalid } from '@angular/compiler/src/render3/view/util';
import { HttpHeaders } from '@angular/common/http';
import { QuoteService } from 'src/app/Modules/motor/Modules/quote/Services/quote.service';
import { ListingService } from 'src/app/Modules/listing/Services/listing.service';

@Component({
  selector: 'app-update-profile',
  templateUrl: './update-profile.component.html',
  styleUrls: ['./update-profile.component.css']
})
export class UpdateProfileComponent implements OnInit {

  updateform:FormGroup;
  userName:any;
  flowMode:any;
  password:any;
  userType:string;
  editable: boolean = false;
  branchs :any[] =[];

  constructor(public dialog: MatDialog,private listingService:ListingService,
    private _formbuilder: FormBuilder,private toastr: ToastrService,
    public loginservice:LoginService,private route: ActivatedRoute,private quoteService:QuoteService) {

    this.updateform =this._formbuilder.group({
      name:['',[Validators.required]],
      userType :['',[Validators.required]],
      emailid :['',[Validators.required,Validators.pattern(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)]],
     // dob :['',[Validators.required]],
     agentname :['',[Validators.required]],
      mobileno:['',[Validators.required,Validators.minLength(8),Validators.pattern('^(0|[0-9][0-9]*)$')]],
      agentId:['',[Validators.required]],
      location:[``,[Validators.required]],
    })
   }

  ngOnInit() {
    
    this.getAllLOvs1("upbranch");
    this.route.queryParams.subscribe(params => {
      this.userName = params["username"];     
      this.flowMode = params["flowMode"];  
    });
    if(this.flowMode!=undefined && this.flowMode!=null && this.flowMode!="" && this.flowMode=="update"){
      var userName = sessionStorage.getItem("userName") ;
      this.loginservice.viewprofile(userName).subscribe((res: any)=>{
       if(res.responseBody){
        let agentName  = res.responseBody.profilelist["0"].agentName;
        let agentid  = res.responseBody.profilelist["0"].agentId;
        let Name = res.responseBody.profilelist["0"].name;
        let emailId  =res.responseBody.profilelist["0"].emailId;
        let mobileNo   =res.responseBody.profilelist["0"].mobileNo;
         if(res.responseBody.profilelist["0"].userType =="AGN"){
           this.userType="AGENT";
         }
         else{
           this.userType=res.responseBody.profilelist["0"].userType;
         
         }
         this.updateform.patchValue({
          name:Name,
          emailid:emailId,
          mobileno : mobileNo,
          agentId :agentid,
          userType:this.userType, 
          agentname:agentName,
        });
       } 
     }); 
      }
       //to unlock the QQ
   
   var unlock = sessionStorage.getItem('LOCK');
   if(unlock =="L"){
     
     var userName =sessionStorage.getItem('userName');
     this.quoteService.unlockQuotedetails(userName).subscribe((data:any)=>{
       
       console.log(data);
     })
   }
 //END 
  }

  Submit(updateform){
    
   
    if(updateform.value.userType =="AGENT"){
        updateform.value.userType = "AGN";
    }
   if(this.updateform.valid){
     this.updateform.value.username = sessionStorage.getItem('userName');
    let Form = JSON.stringify(this.updateform.value);
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json');
      this.loginservice.updateprofile(Form).subscribe((res: any)=>{
        console.log(res); 
        if(res.responseBody){
          this.toastr.success(res.responseBody.validationMsg, undefined, {
            positionClass: 'toast-bottom-right',
            timeOut: 6000
       });
        }    
      });
      this.dialog.closeAll();
    }else{
       this.toastr.error("Please Enter the value", undefined, {
        positionClass: 'toast-bottom-right',
        timeOut: 6000
   });
    }
   
  }

  mobileChange(){
    
    var str = this.updateform.value.mobileno.slice(0, 1);
    if(str !== "5"){
      this.updateform.patchValue({  
        mobileno:""
      });
      this.toastr.error("Mobile number should start with number 5", undefined, {
        positionClass: 'toast-bottom-right',
        timeOut: 6000
   });
    }
    else if(this.updateform.value.mobileno == "" || this.updateform.value.mobileno == undefined) {
      this.updateform.patchValue({  
        mobileno:""
      });
      this.toastr.error("Please Enter Mobile No", undefined, {
        positionClass: 'toast-bottom-right',
        timeOut: 6000
   });
     }
  }


  getAllLOvs1(value:string){
    
     this.listingService.getListingLOVs(value).subscribe((res:any)=>{
       if(res.responseBody != undefined){
         this.branchs = res.responseBody.divisioncodeup;
         console.log("Lov's",res.responseBody);
               
       }
     
     })
   }
}
